module.exports = __webpack_public_path__ + "img/bg-0-pi.444da44f.png";